module.exports = __webpack_public_path__ + "img/sending_3.c19ce465.png";